import React, { useEffect, useState } from "react";
import {removeIgnoreItems} from '../../utils';

import HCarousel from '../HCarousel/HCarousel';
import HnCarousel from '../HnCarousel/HnCarousel';
import VCarousel from "../VCarousel/VCarousel";
import FeaturedItems from "../FeaturedItems/FeaturedItems";
import Grid from '../Grid/Grid';

const ListItem = ({items, fadeOutTiming}) => {	
	const [newItems, setNewItems] = useState([]);

	useEffect(()=> {
		if(items.item && items.item.length > 0) {
			const tmpItems = removeIgnoreItems(items);
			setNewItems(tmpItems);
		}
	},[items]);

	const renderModeView = () => {
		switch(items.viewmode) {
			case "h_carrousel_with_f_number":
				return <HCarousel items={newItems} fadeOutTiming={ fadeOutTiming }/>
			case "v_carrousel_view":
				return <VCarousel details={items} items={newItems}/>
			case "h_carrousel_view":
				return <HnCarousel details={items} items={newItems}/>
			case "f_item_view":
				return <FeaturedItems details={items} items={newItems}/>
			case "grid":
				return <Grid items={newItems}/>
			default:
				return;
		}
	}

	return <>{newItems.length > 0 && renderModeView()}</>
}

export default ListItem;